export const EMPTY_ACTIVITY_STATUS_CHART = [{ legend: '', value: 100 }];
